import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/state/AuthContext.tsx'
import { Layout } from '@/components/Layout.tsx'
import { SECTIONS } from '@/routes/registry.ts'
import Welcome from '@/routes/Welcome.tsx'
import ResetPassword from '@/routes/ResetPassword.tsx'
import Home from '@/routes/Home.tsx'
import NotebookDetail from '@/routes/NotebookDetail.tsx'
import TogetherPrompt from '@/routes/TogetherPrompt.tsx'
import { Sprig } from '@/components/Botanical.tsx'

/**
 * The whole site sits behind the door. Until we know who is here, we show
 * nothing but a growing sprig — better than flashing a login form at someone
 * who is already signed in.
 */
export default function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Sprig tone="var(--c-sage)" className="h-24 w-auto animate-sway opacity-60" />
      </div>
    )
  }

  // Resetting a password happens while signed out, so it has to sit outside
  // the gate — otherwise the link from the email just shows the login form.
  if (!user) {
    return (
      <Routes>
        <Route path="/reset" element={<ResetPassword />} />
        <Route path="*" element={<Welcome />} />
      </Routes>
    )
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        {SECTIONS.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path="/notebooks/:id" element={<NotebookDetail />} />
        <Route path="/together/:id" element={<TogetherPrompt />} />
        <Route path="/reset" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
